if (!customElements.get('customer-care')) {
  customElements.define('customer-care', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('.customer-care__category, .customer-care__navigation details').forEach(category => {
        category.open = window.matchMedia('(min-width: 750px)').matches;
      });
      this.media = window.matchMedia('(min-width: 750px)');
      this.media.addEventListener('change', event => {
        this.querySelectorAll('.customer-care__category, .customer-care__navigation details').forEach(category => { category.open = event.matches; });
      }, options);
      const form = this.querySelector('[data-care-search]');
      if (form) {
        form.hidden = false;
        const input = form.querySelector('[data-care-query]');
        const results = form.querySelector('[data-care-results]');
        const status = form.querySelector('[data-care-search-status]');
        const global = form.querySelector('[data-care-global]');
        const globalUrl = global.getAttribute('href');
        const topics = [...this.querySelectorAll('[data-care-topic]')];
        let previousQuery = '';
        form.addEventListener('submit', event => {
          event.preventDefault();
          const query = input.value.trim().toLowerCase();
          const terms = query.split(/\s+/).filter(term => term && !['where','is','my','the','a','an','i','only','received','of'].includes(term));
          const productIntent = /\b(parts?|hardware|screws?|assembly|assemble|manuals?|warranty|defect\w*|installation|install)\b|broken panel|broken door/.test(query);
          const intents = [
            [/missing (box|carton)|received \d+ boxes|damaged box|crushed carton/, '/pages/delivery-problems'],
            [/where is my order|track(ing)?|track package/, '/pages/order-help'],
            [/money back|refund/, '/pages/refunds'],
            [/monthly payment|affirm|installments/, '/pages/financing'],
            [/truck delivery|curbside|pallet|appointment/, '/pages/freight-delivery'],
          ];
          const destination = intents.find(([pattern]) => pattern.test(query))?.[1];
          results.replaceChildren();
          const matches = !productIntent && terms.length ? topics.filter(topic => {
            const text = `${topic.textContent} ${topic.dataset.keywords}`.toLowerCase();
            return (destination && (topic.getAttribute('href') === destination || (destination === '/pages/financing' && topic.getAttribute('href') === '/pages/flexible-payment-options'))) || terms.every(term => text.includes(term));
          }) : [];
          for (const topic of matches) {
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.href = topic.href;
            link.textContent = topic.textContent;
            li.append(link);
            results.append(li);
          }
          results.hidden = matches.length === 0;
          status.textContent = !query ? '' : matches.length ? `${status.dataset.results} (${matches.length})` : status.dataset.empty;
          const hint = form.querySelector('[data-care-product-hint]');
          hint.hidden = !productIntent;
          results.before(hint);
          if (productIntent) status.textContent = '';
          global.href = `${globalUrl}?q=${encodeURIComponent(input.value.trim())}`;
          this.dispatchEvent(new CustomEvent('customer-care:search', { bubbles: true, detail: { term: query, count: matches.length, productIntent, reformulation: !!previousQuery && previousQuery !== query } }));
          previousQuery = query;
        }, options);
        this.addEventListener('click', event => {
          const link = event.target.closest('a');
          if (!link || !previousQuery) return;
          this.dispatchEvent(new CustomEvent('customer-care:search-click', { bubbles: true, detail: { destination: link.getAttribute('href'), afterSearch: true } }));
        }, options);
      }
      const select = this.querySelector('[data-care-topic-select]');
      if (select) {
        const common = this.querySelector('[data-care-common]');
        const reason = this.querySelector('[data-care-return-reason]');
        const update = () => {
          this.querySelectorAll('[data-care-fields]').forEach(group => {
          group.hidden = !group.dataset.careFields.split(' ').includes(select.value);
          group.querySelectorAll('input,select,textarea').forEach(field => { field.disabled = group.hidden; });
          });
          common.hidden = false;
          common.querySelectorAll('input,select,textarea,button').forEach(field => { field.disabled = common.hidden || !!field.closest('[data-care-fields]')?.hidden; });
          const route = this.querySelector('[data-care-return-routing]');
          const link = route.querySelector('a');
          const product = select.value === 'return' && reason.value === 'missing_part';
          const delivery = select.value === 'return' && ['missing_carton', 'damage'].includes(reason.value);
          route.hidden = !product && !delivery;
          if (!route.hidden) {
            link.href = product ? link.dataset.productUrl : link.dataset.deliveryUrl;
            link.textContent = product ? link.dataset.productLabel : this.querySelector('[data-care-topic-select] option[value="delivery"]').textContent;
          }
          common.querySelector('[type="submit"]').disabled = common.hidden || product;
        };
        select.addEventListener('change', update, options);
        reason.addEventListener('change', update, options);
        if (!this.intakeInitialized) {
          const params = new URLSearchParams(window.location.search);
          for (const [field, value] of [
            [select, params.get('topic')],
            [this.querySelector('[data-care-order-request]'), params.get('request')],
            [this.querySelector('[data-care-account-issue]'), params.get('issue')],
          ]) {
            if (field && [...field.options].some(option => option.value === value)) field.value = value;
          }
          this.intakeInitialized = true;
        }
        // Shopify's error redirect does not retain arbitrary contact fields.
        // Leave the topic visible so a failed submission can be classified again.
        update();
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
